// Generated by CoffeeScript 2.7.0
var ResponsiveItem;

export default ResponsiveItem = {
  props: {
    headers: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    operations: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  template: `<div class="responsive-item-wrapper">
  <div class="responsive-item-top">
    <template v-for='( header, key ) in headers'>
      <div class="cell-wrapper"
           @click="clickedCellFunc(header)">
        <div class="header-title">{{ header }}</div>
        <div class="cell-value">
          <slot name="cellInfo" :attr="key"></slot>
        </div>
      </div>
    </template>
    <div class="cell-wrapper"" v-if='operations.length'>
      <div class="header-title">操作</div>
      <div class="operation">
        <slot name="operations">
          <template v-for="operation in operations">
            <button class="text-btn"
                    :class="operation.color"
                    @click="operationClickedFunc(operation)">{{ operation.label }}</button>
          </template>
        </slot>
      </div>
    </div>
  </div>
  <div class="responsive-item-bottom" v-if="$slots.extroText">
    <slot name="extroText">
      <div class="extro-message">
        <span class="message-title mr-2">留言</span>
        <span class="message-content">{{ item.message }}</span>
      </div>
    </slot>
  </div>
</div>`,
  methods: {
    clickedCellFunc: function(header) {
      return this.$emit('cellClicked', header);
    },
    operationClickedFunc: function(operation) {
      return this.$emit('operationClicked', operation);
    }
  }
};
